import React, { Component } from 'react';
import PropTypes from 'prop-types';
import config from 'react-global-configuration';
import { withI18n } from '@lingui/react';
import { t } from '@lingui/macro';
import '../../styles/core.scss';
import css from './reload.scss';
import Header from '../../components/header/header';
import Filter from '../filter/filter';
import Library from '../library/library';
import { initialConfig, getParamByName } from '../../config';
import { getProductNameById } from '../../helpers/utils';
import { getLocale } from '../../helpers/locale';

class Reload extends Component {
  static propTypes = {
    i18n: PropTypes.object
  };

  constructor(props) {
    super(props);
    initialConfig();
    this.productId = getParamByName('productId') || -1;
    this.productName = '';
  }

  getHeaderText(i18n) {
    const locale = getLocale();

    if (locale.toLowerCase() === 'es-mx') {
      return `${i18n._(t`library`)} ${this.productName}`;
    }

    return `${this.productName} ${i18n._(t`library`)}`;
  }

  getBackText(i18n) {
    const locale = getLocale();

    if (locale.toLowerCase() === 'es-mx') {
      return `${i18n._(t`Back`)}`;
    }

    return `${i18n._(t`Back`)}`;
  }

  render() {
    const { i18n } = this.props;
    const backUrl = config.get('backUrl');

    this.productName = getProductNameById(Number(this.productId));
    return (
      <div className={css.component} >
        <div className={css.reloadform} >
          <Header text={this.getHeaderText(i18n)} btnTxt={this.getBackText(i18n)} backUrl={backUrl} />
          <Filter i18n={this.props} />
          <Library i18n={this.props} />
        </div>
      </div>
    );
  }
}

export default withI18n()(Reload);
